export default __webpack_public_path__ + "static/media/782.2ff8469c.png";